$(function () {
  $(".js-navi__toggle").on("click", function () {
    $(this).toggleClass("is-active");
    $(".l-header").toggleClass("is-active");
    $("body").toggleClass("is-lock");
    $(".js-global-navi").toggleClass("is-active");
  });

  $(window).on("load scroll resize", function () {
    $("html").addClass("is-loaded");
    var body = $("body");
    var offset = 400;

    if ($(this).scrollTop() > offset) {
      body.addClass("is-fixed--contents");
    } else {
      body.removeClass("is-fixed--contents");
    }
  });
});

const targets = document.querySelectorAll(".js-curtain");

targets.forEach((target) => {
  gsap.fromTo(
    target.querySelector("img"),
    {
      y: 0,
    },
    {
      y: -80, // y方向-に60px移動させる
      ease: "ease-out", // イージングなし
      scrollTrigger: {
        trigger: target, // ScrollTriggerの開始位置を計算するために使用される要素
        start: "top bottom", // 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
        end: "bottom top", // 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
        scrub: 1.8, // 要素を1秒遅れで追従させる
        // markers: true, // 開始位置、終了位置を調整確認する際に使用します
        onEnter: () => target.classList.add("is-inview"), // 表示領域に入ったときに .is-inview クラスを追加
        // onLeave: () => target.classList.remove("is-inview"), // 表示領域から外れたときに .is-inview クラスを削除
      },
    }
  );
});

const targetsHalf = document.querySelectorAll(".js-curtain_half");

targetsHalf.forEach((target) => {
  gsap.fromTo(
    target.querySelector("img"),
    {
      y: 0,
    },
    {
      y: -30, // y方向-に60px移動させる
      ease: "ease-out", // イージングなし
      scrollTrigger: {
        trigger: target, // ScrollTriggerの開始位置を計算するために使用される要素
        start: "top bottom", // 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
        end: "bottom top", // 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
        scrub: 1.8, // 要素を1秒遅れで追従させる
        // markers: true, // 開始位置、終了位置を調整確認する際に使用します
        onEnter: () => target.classList.add("is-inview"), // 表示領域に入ったときに .is-inview クラスを追加
        // onLeave: () => target.classList.remove("is-inview"), // 表示領域から外れたときに .is-inview クラスを削除
      },
    }
  );
});

const targetsStill = document.querySelectorAll(".js-curtain__still");

targetsStill.forEach((target) => {
  gsap.fromTo(
    target.querySelector("img"),
    {
      y: 0,
    },
    {
      y: 0, // y方向-に60px移動させる
      ease: "ease-out", // イージングなし
      scrollTrigger: {
        trigger: target, // ScrollTriggerの開始位置を計算するために使用される要素
        start: "top bottom", // 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
        end: "bottom top", // 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
        scrub: 1.8, // 要素を1秒遅れで追従させる
        // markers: true, // 開始位置、終了位置を調整確認する際に使用します
        onEnter: () => target.classList.add("is-inview"), // 表示領域に入ったときに .is-inview クラスを追加
        // onLeave: () => target.classList.remove("is-inview"), // 表示領域から外れたときに .is-inview クラスを削除
      },
    }
  );
});

const targetsParallaxImage = document.querySelectorAll(".js-parallax__image");

targetsParallaxImage.forEach((target) => {
  gsap.fromTo(
    target.querySelector("img"),
    {
      y: 0,
    },
    {
      y: -120, // y方向-に60px移動させる
      ease: "ease-out", // イージングなし
      scrollTrigger: {
        trigger: target, // ScrollTriggerの開始位置を計算するために使用される要素
        start: "top bottom", // 1つ目の値がtriggerで指定した要素の開始位置　2つ目の値が画面の開始位置
        end: "bottom top", // 1つ目の値がtriggerで指定した要素の終了位置　2つ目の値が画面の終了位置
        scrub: 1.5, // 要素を1秒遅れで追従させる
        // markers: true, // 開始位置、終了位置を調整確認する際に使用します
        onEnter: () => target.classList.add("is-inview"), // 表示領域に入ったときに .is-inview クラスを追加
        // onLeave: () => target.classList.remove("is-inview"), // 表示領域から外れたときに .is-inview クラスを削除
      },
    }
  );
});

// swiper
let SwiperMarquee = new Swiper(".js-marquee", {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 12000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

let SwiperMarqueeBigtypo = new Swiper(".js-marquee__bigtypo", {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 20000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

let SwiperTopPickup = new Swiper(".js-top__pickup", {
  slidesPerView: 1.2,
  spaceBetween: 24,
  // slidesPerView: "auto",
  loop: true,
  speed: 800,

  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  breakpoints: {
    769: {
      spaceBetween: 40,
      slidesPerView: "auto",
    },
  },
  navigation: {
    nextEl: ".js-top__pickup__next",
    prevEl: ".js-top__pickup__prev",
  },
});

let topicsList = new Swiper(".js-topics__list", {
  // direction: "vertical",
  loop: true,
  speed: 1200,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
  },
});

let SwiperTopWorks = new Swiper(".js-top__works", {
  slidesPerView: 1.2,
  spaceBetween: 24,
  // slidesPerView: "auto",
  loop: true,
  speed: 800,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  breakpoints: {
    769: {
      spaceBetween: 40,
      slidesPerView: "auto",
    },
  },
  navigation: {
    nextEl: ".js-top__works__next",
    prevEl: ".js-top__works__prev",
  },
});

document.addEventListener("DOMContentLoaded", function () {
  var swiper;
  // 有効化時のオプションを記述
  function initializeSwiper() {
    swiperTopJournal = new Swiper(".js-top__journal", {
      spaceBetween: 24,
      slidesPerView: 1.1,
      // loop: true,

      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      navigation: {
        nextEl: ".js-top__journal__next",
        prevEl: ".js-top__journal__prev",
      },
    });
  }
  // 無効化する用の記述
  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }
  // if分を用いて横幅に応じて関数を実行
  function handleResize() {
    var w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (w < 500) {
      if (!swiper) {
        initializeSwiper();
      }
    } else {
      destroySwiper();
    }
  }
  // 初回実行
  handleResize();
  window.addEventListener("resize", handleResize);
});

$(function () {
  //SERVICE 文章の開閉
  $(".js-btn-more").click(function () {
    $(".js-btn-more__target").addClass("is-show");
    $(this).fadeOut(300);
  });
  //JOURNAL等のmoreボタン
  var post_add = 6;
  var post_count = post_add - 1;
  var post_more_btn = $(".js-post-more");
  var post_more_target = $(".js-post-more__target>li");
  var post_num = post_more_target.length;
  post_more_btn.hide();
  post_more_target.slice(0, post_add).show();
  if (post_num > post_add) {
    post_more_btn.show();

    post_more_btn.click(function () {
      for (var i = 0; i < post_add; i++) {
        post_more_target.eq(post_count + 1).fadeIn(300);
        post_count++;
        if (post_count + 1 >= post_num) {
          post_more_btn.fadeOut(300);
          break;
        }
      }
    });
  }
  //活動事例のmoreボタン
  var works_add = 4;
  var works_count = works_add - 1;
  var works_more_btn = $(".js-works-more");
  var works_more_target = $(".js-works-more__target>li");
  var works_num = works_more_target.length;
  works_more_btn.hide();
  works_more_target.slice(0, works_add).show();
  if (works_num > works_add) {
    works_more_btn.show();

    works_more_btn.click(function () {
      for (var i = 0; i < works_add; i++) {
        works_more_target.eq(works_count + 1).fadeIn(300);
        works_count++;
        if (works_count + 1 >= works_num) {
          works_more_btn.fadeOut(300);
          break;
        }
      }
    });
  }
  //リンク内リンク
  $(".js-link-priority").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var link_url = $(this).attr("data-url");
    location.href = link_url;
  });
  $(".js-link-copy").click(function () {
    const element = document.createElement("input");
    element.value = location.href;
    document.body.appendChild(element);
    element.select();
    document.execCommand("copy");
    document.body.removeChild(element);
    alert("URLをコピーしました");
  });
});

$(function () {
  $(window).on("load", function () {
    $(".js-bnr__floating").hide();
  });
  // 初期状態で非表示にする
  $(".js-bnr__floating").hide();

  // スクロールイベントを監視
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 1000) {
      $(".js-bnr__floating").fadeIn();
    } else {
      $(".js-bnr__floating").fadeOut();
    }
  });

  $(".js-bnr__floating_close").on("click", function (event) {
    $(".js-bnr__floating").hide();
    const now = new Date().getTime();
    const expires = now + 3600000 * 48; // 2日後のタイムスタンプを計算
    localStorage.setItem("floatingBnr", "on");
    localStorage.setItem("floatingBnrExpires", expires);
    event.preventDefault();
  });

  const floatingBnr = localStorage.getItem("floatingBnr");
  const floatingBnrExpires = localStorage.getItem("floatingBnrExpires");
  const now = new Date().getTime();

  if (floatingBnr !== "on" || now > floatingBnrExpires) {
    $(".js-bnr__floating").show();
  } else {
    $(".js-bnr__floating").hide();
  }

  if ("#clear" == location.hash) {
    localStorage.removeItem("floatingBnr");
    localStorage.removeItem("floatingBnrExpires");
  }
});
